import { PRICING_TIERS } from "@/components/landing/pricing-data";

export const STORAGE_KEY_PACKAGES = "restomat_selected_packages";
export const STORAGE_KEY_BILLING = "restomat_billing_cycle";
export const STORAGE_KEY_PENDING_PAYMENT = "restomat_pending_payment";

export function getStoredPackages(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY_PACKAGES);
    if (stored) {
      const parsed = JSON.parse(stored) as string[];
      // A stored selection from before #609 names packages that no longer exist; filtering
      // against the current tiers drops them instead of carrying a dead id into checkout.
      return parsed.filter((id) => PRICING_TIERS.some((p) => p.id === id));
    }
  } catch {
    // Invalid JSON
  }
  return [];
}

export function setStoredPackages(packages: string[]): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY_PACKAGES, JSON.stringify(packages));
}

export function clearStoredPackages(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY_PACKAGES);
}

export function getStoredBilling(): "monthly" | "yearly" {
  if (typeof window === "undefined") return "yearly";
  const stored = sessionStorage.getItem(STORAGE_KEY_BILLING);
  return stored === "monthly" || stored === "yearly" ? stored : "yearly";
}

export function setStoredBilling(billing: "monthly" | "yearly"): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY_BILLING, billing);
}

export function clearAllStoredSelection(): void {
  clearStoredPackages();
}

const PENDING_PAYMENT_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export function getPendingPayment(): { timestamp: number } | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY_PENDING_PAYMENT);
    if (stored) {
      const parsed = JSON.parse(stored) as { timestamp: number };
      // Clear stale pending payment after timeout
      if (Date.now() - parsed.timestamp > PENDING_PAYMENT_TIMEOUT_MS) {
        clearPendingPayment();
        return null;
      }
      return parsed;
    }
  } catch {
    // Invalid JSON
  }
  return null;
}

export function setPendingPayment(): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(
    STORAGE_KEY_PENDING_PAYMENT,
    JSON.stringify({ timestamp: Date.now() })
  );
}

export function clearPendingPayment(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY_PENDING_PAYMENT);
}
